interface OverviewSettingRowProps {
  label: string;
  value: React.ReactNode;
  fullWidth?: boolean;
}

export const OverviewSettingRow = ({ label, value, fullWidth = false }: OverviewSettingRowProps) => {
  if (fullWidth) {
    return (
      <div className="space-y-2">
        <div className="text-sm font-medium text-gray-700">{label}</div>
        <div className="text-sm text-gray-900">{value}</div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div className="text-sm font-medium text-gray-700 flex-shrink-0">{label}</div>
      <div className="text-sm text-gray-900 text-right min-w-0">{value}</div>
    </div>
  );
};
